import React from "react";
import { addDecimalPoints } from "../../shared/utils";

const PriceRange = ({ range, goToMonth, getMostRankedMonth, tripType, goIntent, backIntent }) => {
	if (!range || (tripType === "RT" && (!goIntent || backIntent))) return null;

	const renderPriceRangeCell = (val, i, self) => {
		const props = {
			val,
			i,
			range,
			goToMonth,
			getMostRankedMonth,
			key: i
		};

		return <PriceRangeCell {...props} />;
	};

	return (
		<div className="price-range">
			<p className="price-range__text">Preços sujeitos à disponibilidade dos voos</p>
			<div className="price-range__range">{range.map(renderPriceRangeCell)}</div>
			<div className="price-range__text">
				<span>menor preço</span>
				<span>maior preço</span>
			</div>
		</div>
	);
};

const PriceRangeCell = props => {
	const { val, i, range, goToMonth, getMostRankedMonth } = props;
	let value = parseFloat(val)
		.toFixed(2)
		.toString()
		.split(".")[0];

	let str = addDecimalPoints(value);

	const onClick = () => {
		const month = getMostRankedMonth(i);
		goToMonth(month);
	};

	return (
		<div onClick={onClick} className={`price-range__cell price-range__cell--rank-${i}`} key={i}>
			<span className="currency">R$</span>
			<span className="value">{str + (i == 0 ? "" : "+")}</span>
		</div>
	);
};

export default PriceRange;
